import { CUSTOMERS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import CustomerPage from "./container/CustomerPage";

export default function getSettingsRoute(userAuth) {
  const { account, bazaar } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [bazaar.name]: [bazaar.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: CUSTOMERS,
    withSidebar: true,
    withAppBar: true,
    component: CustomerPage,
  };
}
